
import {BaseModel} from './BaseModel'

export class Query extends BaseModel {
  schema = '/query'
  constructor(params = {}) {
    return super(params, '/query')
  }

  /** Do not allow id to be saved in a query
   *  id is typically a display level value that should be added
   *  if the use case requires the user to click through to a unique item
   */
  create(){
    var hasId = false
    if(this.params.resultParams.outputFields.includes('id')){
      this.params.resultParams.outputFields = this.params.resultParams.outputFields.filter(p=>p!=='id')
      hasId = true
    }
    const request = super.create()
    if(hasId){
      this.params.resultParams.outputFields.unshift('id')
    }
    return request
  }

  /** Do not allow id to be saved in a query
   *  id is typically a display level value that should be added
   *  if the use case requires the user to click through to a unique item
   */
  update(){
    var hasId = false
    if(this.params.resultParams.outputFields.includes('id')){
      this.params.resultParams.outputFields = this.params.resultParams.outputFields.filter(p=>p!=='id')
      hasId = true
    }
    const request = super.update()
    if(hasId){
      this.params.resultParams.outputFields.unshift('id')
    }
    return request
  }

}

